import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { azureAllAccountsGroupedByOrgsSelector } from "./azureAllAccountsGroupedByOrgsSelector";
import { providerAllAccountsCombiner } from "../../combiners/providerAllAccountsCombiner";

export const azureAllAccountsSelector = createDraftSafeSelector(
  [azureAllAccountsGroupedByOrgsSelector],
  providerAllAccountsCombiner,
);
